"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["@media (max-width:978px){.top-spacing[_ngcontent-%COMP%]{padding-top:10%}}@media (min-width:979px){.top-spacing[_ngcontent-%COMP%]{padding-top:5%}}"];
exports.styles = styles;
//# sourceMappingURL=app.component.scss.shim.ngstyle.js.map